var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"btn",style:({
    background: _vm.disabled ? 'rgba(0, 0, 0, 0.16)': _vm.background,
    color: _vm.disabled ? 'rgba(0, 0, 0, 0.16)' : _vm.colorTexto,
    borderRadius: `${_vm.radius}px`,
    maxWidth: _vm.width ? _vm.width : ''
  }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }